import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginInfoService } from '@pg-app/auth/services/login-info.service';
import { PinCodeService } from '@pg-app/auth/services/pin-code.service';
import { AuthService } from '@pg-app/core/services/auth.service';
import { StoreProvider } from '@pg-app/core/services/storeProvider/store.provider';
import { RegistrationStep2Service } from '@pg-app/client/services/registrationStep2.service';
import { VerifyCodeErrorEnum } from '@nttp/enum/verify-code-error-type.enum';
import { AuthyTicketTypeEnum } from '@nttp/enum/authy-ticket-type.enum';
import { VerifyTypeSendCodeEnum } from '@nttp/enum/verify-type.enum';
import { ShareService } from '@nttp/common-service/share-service';
import { ClientProfileService } from '@pg-app/client/services/client-profile.service';
import { environment } from '@pg-env/environment';

@Component({
  selector: 'np-login-step3',
  templateUrl: './login-step3.component.html',
  styleUrls: ['./login-step3.component.scss']
})
export class LoginStep3Component {
  btnName = 'Sign in';
  pinCodeError = null;
  ticketType = AuthyTicketTypeEnum.Login;
  sendOnetouchSuccess = false;

  constructor(
    private router: Router,
    private pinCodeService: PinCodeService,
    public loginInfo: LoginInfoService,
    private authService: AuthService,
    private store: StoreProvider,
    public registerService: RegistrationStep2Service,
    private shareService: ShareService,
    private clientService: ClientProfileService,
  ) {}

  login(event = null) {
    this.pinCodeError = null;
    this.pinCodeService
      .verifyCode({
        verificationCode: event ? event.code : null,
        userId: this.loginInfo.userId,
        portalId: this.loginInfo.portalId,
        verificationType: event ? event.verificationType : VerifyTypeSendCodeEnum.Onetouch
      })
      .subscribe(
        res => {
          this.store.set('accessToken', res.token);
          this.store.set('refreshToken', res.refreshToken);
          this.store.set('tokenType', res.tokenType);
          this.store.set('userId', res.userId);
          this.store.set('clientId', res.clientId);
          this.store.set('portalTypes', res.portalTypes);
          this.store.set('role', res.roles);

          this.authService.accessToken = res.token;
          this.authService.refreshToken = res.refreshToken;
          this.authService.tokenType = res.tokenType;
          this.authService.userId = res.userId;
          this.authService.clientId = res.clientId;

          // reset login info
          this.loginInfo.currentUserStep = '';
          this.loginInfo.userId = '';

          if (this.loginInfo.isClient) {

            this.clientService.getProfiles({email: this.loginInfo.email}).subscribe((res: any[]) => {
              this.loginInfo.profiles = res;
              if (this.loginInfo.profiles.length == 1){
                const currentProfile = this.loginInfo.profiles[0];
                var email = this.loginInfo.email;
                var clientId = environment.clientId;
                var data = {
                  leadId: currentProfile.leadId,
                  email: email,
                  clientId: clientId, 
                  leadName: currentProfile.leadName
                };
                this.clientService.changeSelectedAccount(data).subscribe(res => {
                    this.authService.updateAccessToken(res);
                    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
                    this.router.navigate(['client/dashboard'])
                  );
                });
              } else {
                this.router.navigate(['/auth/login/profile-switching']);
              }
            })
          } else {
            this.shareService.accountType$.subscribe(data => {
              if (data.isStep2Completed) {
                this.router.navigate(['/partner', 'dashboard']);
              } else {
                this.router.navigate(['/partner/register/step-2']);
              }
            });

          }
        },
        err => {
          this.pinCodeError = VerifyCodeErrorEnum.InvalidCode;
        }
      );
  }

  exceedInvalidCode() {
    this.loginInfo.currentUserStep = '';
    this.router.navigate(['auth/login/login-error-phone']);
  }

  sendCode(event = null) {
    this.pinCodeError = null;
    this.pinCodeService
      .resendCode({
        pincode: this.loginInfo.pinCode,
        userId: this.loginInfo.userId,
        IsTryAgain: event ? event.isTryAgain : false,
        portalId: this.loginInfo.portalId,
        verificationType: event ? event.method : VerifyTypeSendCodeEnum.Onetouch,
        sendVerificationCode: true
      })
      .subscribe(
        res => {
          this.loginInfo.userId = res.userId;
          if (event && event.isTryAgain) {
            this.pinCodeError = VerifyCodeErrorEnum.ResendCode;
          }
          if (!event) {
            this.sendOnetouchSuccess = true;
          }
        }
      );
  }
}
